import infoIcon from 'assets/images/icons/info.png';
import { empty, formatInputNumber, formatNumberTo } from 'helpers/common';
import sanitize from 'helpers/sanitize';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import personIcon from 'assets/images/icons/person.png';
import peopleIcon from 'assets/images/icons/people.png';
import toolIcon from 'assets/images/icons/tool.png';
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useTranslation } from 'translation/useTranslation'
import EvaluationDUS from './Custom/DUS/Evaluation';
import EvaluationStateEmployee from './Custom/DB/Evaluation';
import EditorInput from 'components/ui/EditorInput';
import ExpandableHtml from 'components/ui/ExpandableHtml';
import ErrorAlert from 'components/ui/ErrorAlert';
import PayoutPointsMapping from './PayoutPointsMapping';
import { Button, Input, InputAffix, NativeSelect } from 'components/ui';

function DefaultSystematicObectiveRow({ data, hasSub, settings, balancedScorecardDetails, handleLevelChange, readOnlyMode, levels, useGeneral, extremeLevels, weighted, errorField = null }) {

  const { editableTranslate } = useTranslation();

  const savedSystematicObjective = useMemo(() => {
    if (balancedScorecardDetails?.agreement_data?.systematicObjectives && Array.isArray(balancedScorecardDetails?.agreement_data?.systematicObjectives)) {
      const filtered = balancedScorecardDetails.agreement_data.systematicObjectives.filter(o => o.name === data.systematicObjectiveGridName);

      if (filtered.length > 0) {
        let agreed = filtered[0].agreed;

        if (agreed) return filtered[0];
      }
    } else if (!balancedScorecardDetails) {
      if (data?.systematicObjectiveAgreeObjective) {
        return {
          weight: null,
          sub: !hasSub ? null : data?.systematicObjectivesubCriteria?.map(o => ({
            name: o?.systematicSubObjectiveGridName,
            agreed: o?.systematicSubObjectiveAgreeObjective
          }))
        };
      }
    }
    return null;
  }, [data, settings, balancedScorecardDetails]);

  const countAgreed = useMemo(() => {
    if (savedSystematicObjective) {
      return savedSystematicObjective?.sub?.filter(s => s?.agreed).length;
    }
    return 0;
  }, [savedSystematicObjective]);

  const hasNextError = useMemo(() => {
    if (balancedScorecardDetails?.agreement_data?.systematicObjectives && Array.isArray(balancedScorecardDetails?.agreement_data?.systematicObjectives)) {
      for (let i = 0; i < balancedScorecardDetails.agreement_data.systematicObjectives.length; i++) {
        if (balancedScorecardDetails.agreement_data.systematicObjectives[i].name === data.systematicObjectiveGridName) {
          if (balancedScorecardDetails.agreement_data.systematicObjectives?.[i + 1]?.name === errorField?.systematic?.objective?.name) {
            return true;
          }
        }
      }
    }
    return false;
  }, [data, balancedScorecardDetails, errorField]);

  let count = 0;

  return savedSystematicObjective && <>
    <tr className={`${hasSub ? 'tr-criteria' : ''} ${(errorField?.systematic?.objective?.name === data.systematicObjectiveGridName && !errorField?.systematic?.objective?.sub) ? 'invalid-tr' : ''} ${errorField?.systematic?.objective?.sub || hasNextError ? 'tr-no-border-bottom' : ''}`}>
      <td colSpan={hasSub ? 2 : 1} className={hasSub ? 'pl-3' : 'no-sub'}>{data.systematicObjectiveGridName}</td>
      {
        !hasSub && <td>{data.systematicObjectiveGridDescription}</td>
      }
      {
        weighted && <td className="text-right">{!hasSub && savedSystematicObjective?.weight ? savedSystematicObjective?.weight + '%' : ''}</td>
      }
      <td className="text-right">
        {
          !hasSub && <>
            <NativeSelect data-testid="level-select" className="d-inline-block" disabled={readOnlyMode} onChange={(e) => handleLevelChange(e, 'systematic', { name: data.systematicObjectiveGridName })} value={savedSystematicObjective?.level || ''}>
              <option value=""></option>
              {
                levels.map((item, i) => {
                  return <option key={i}>{item.level}</option>
                })
              }
            </NativeSelect>
            <DefaultLevelComment type="systematic" useGeneral={useGeneral} settings={settings} data={savedSystematicObjective} extremeLevels={extremeLevels} readOnlyMode={readOnlyMode} handleSave={v => handleLevelChange(v, 'systematic', savedSystematicObjective, 'comment')} />
          </>
        }
      </td>
      <td className="text-right">{!hasSub && savedSystematicObjective?.value}</td>
      {
        weighted && <td className="text-right">{!hasSub && savedSystematicObjective?.weightedValue}</td>
      }
    </tr>
    {
      hasSub && data.systematicObjectivesubCriteria.map((sub, j) => {
        const filtered = savedSystematicObjective?.sub?.filter(s => s.name === sub.systematicSubObjectiveGridName);
        let savedSub = null;
        if (filtered && filtered.length > 0) savedSub = filtered[0];
        if (savedSub?.agreed) count++;

        const hasError = (errorField?.systematic?.objective?.name === data.systematicObjectiveGridName && errorField?.systematic?.objective?.sub?.name === sub.systematicSubObjectiveGridName);

        let hasNextError = false;
        if (errorField?.systematic?.objective?.name === data.systematicObjectiveGridName) {
          if (errorField?.systematic?.objective?.sub?.name === data?.systematicObjectivesubCriteria?.[j + 1]?.systematicSubObjectiveGridName) {
            hasNextError = true;
          }
        }

        return savedSub?.agreed && <tr key={j} className={`${hasError ? 'invalid-tr' : ''} ${hasNextError ? 'tr-no-border-bottom' : ''}`}>
          <td className={`arrow-td ${count < countAgreed ? 'has-next' : ''} text-right position-relative`}><i className="bi bi-chevron-right"></i></td>
          <td>{sub.systematicSubObjectiveGridName}</td>
          {
            weighted && <td className="text-right">{savedSub?.weight ? savedSub?.weight + '%' : ''}</td>
          }
          <td className="text-right">
            <NativeSelect data-testid="level-select" className="d-inline-block" disabled={readOnlyMode} onChange={(e) => handleLevelChange(e, 'systematic', { parent: data.systematicObjectiveGridName, name: sub.systematicSubObjectiveGridName })} value={savedSub?.level || ''}>
              <option value=""></option>
              {
                levels.map((item, i) => {
                  return <option key={i}>{item.level}</option>
                })
              }
            </NativeSelect>
            <DefaultLevelComment type="systematic" useGeneral={useGeneral} settings={settings} data={savedSub} extremeLevels={extremeLevels} readOnlyMode={readOnlyMode} handleSave={v => handleLevelChange(v, 'systematic', { parent: data.systematicObjectiveGridName, name: sub.systematicSubObjectiveGridName }, 'comment')} />
          </td>
          <td className="text-right">{savedSub?.value}</td>
          {
            weighted && <td className="text-right">{savedSub?.weightedValue}</td>
          }
        </tr>
      })
    }
    {
      hasSub && <tr className="sum-criteria">
        <td></td>
        <td></td>
        {
          weighted && <td className="text-right">{savedSystematicObjective?.weight}%</td>
        }
        {
          weighted && <td></td>
        }
        <td className="text-right">{editableTranslate('balanced_scorecard.total_criteria')}:</td>
        <td className="text-right">{savedSystematicObjective?.totalValue}</td>
      </tr>
    }
  </>
}

function DefaultSystematicObjective({ settings, balancedScorecardDetails, handleLevelChange, readOnlyMode, levels, countSystematic, useGeneral, extremeLevels, weighted, errorField = null }) {
  const { translate, editableTranslate } = useTranslation();

  return <Fragment>
    <tr className="top-row thead">
      <th colSpan={settings?.shouldHasSubCriteria === true ? 2 : 1}>{editableTranslate('balanced_scorecard.main_criteria')}</th>
      {
        settings?.shouldHasSubCriteria !== true && <th></th>
      }
      {
        weighted && <th className="text-right">{editableTranslate('balance_scorecard.systematic_objective.weighted')}</th>
      }
      <th className="text-right">{editableTranslate('balanced_scorecard.evaluation_level')}</th>
      <th className="text-right">{editableTranslate('balance_scorecard.value')}</th>
      {
        weighted && <th className="text-right">{editableTranslate('balanced_scorecard.weighted_result')}</th>
      }
    </tr>
    {
      settings?.shouldHasSubCriteria === false && settings?.systematicObjectiveDatagrid && settings?.systematicObjectiveDatagrid.map((item, i) => <DefaultSystematicObectiveRow key={i} data={item} settings={settings} balancedScorecardDetails={balancedScorecardDetails} handleLevelChange={handleLevelChange} readOnlyMode={readOnlyMode} levels={levels} useGeneral={useGeneral} extremeLevels={extremeLevels} weighted={weighted} errorField={errorField} />)
    }
    {
      settings?.shouldHasSubCriteria === true && settings?.systematicObjectiveDatagrid_subCriteria && settings?.systematicObjectiveDatagrid_subCriteria.map((item, i) => <DefaultSystematicObectiveRow key={i} data={item} hasSub={true} settings={settings} balancedScorecardDetails={balancedScorecardDetails} handleLevelChange={handleLevelChange} readOnlyMode={readOnlyMode} levels={levels} useGeneral={useGeneral} extremeLevels={extremeLevels} weighted={weighted} errorField={errorField} />)
    }
    {
      countSystematic === 0 && <tr>
        <td colSpan={6} className="text-center">
          {editableTranslate('evaluation.no_systematic_objectives_in_lk')}
        </td>
      </tr>
    }
    <tr className="last-row total-objective-tr">
      <td colSpan={weighted ? 5 : 3} className="text-right font-weight-bold">{editableTranslate('balanced_scorecard.total_system_objective')}:</td>
      <td className="text-right font-weight-bold">{balancedScorecardDetails?.agreement_data?.totalValue?.systematic}</td>
    </tr>
  </Fragment>
}

function DefaultLevelComment({ type = 'individual', useGeneral = false, settings, data, extremeLevels, readOnlyMode, handleSave }) {
  const { editableTranslate } = useTranslation();

  const isMandatory = useMemo(() => {
    if (type === 'individual' || useGeneral) return settings?.individualMandatoryCommentForExtremeRating === true && settings?.individualMandatoryCommentForExtremeRatingType === 'based_on_single_objective' && (data?.level && extremeLevels.individual.includes(data.level));

    return settings?.systematicMandatoryCommentForExtremeRating === true && settings?.systematicMandatoryCommentForExtremeRatingType === 'based_on_single_objective' && (data?.level && extremeLevels.systematic.includes(data.level));
  }, [settings, data, extremeLevels]);

  const [commentError, setCommentError] = useState(false);

  const [showComment, setShowComment] = useState(false);
  const [comment, setComment] = useState(data?.comment || null);

  const handleSaveComment = () => {
    if (comment && !commentError) {
      handleSave(comment);
      setShowComment(false);
    }
  };

  useEffect(() => {
    setCommentError(false);
  }, [showComment]);

  return <>
    {
      !showComment && (
        isMandatory ?
          <Button variant="ghost" className="position-absolute pl-2" data-tooltip-id="extreme-comment-tooltip" onClick={() => setShowComment(!showComment)} data-testid="comment-toggle">
            <i className="bi bi-exclamation-circle-fill text-normal"></i>
          </Button> :
          <Button variant="ghost" className="position-absolute pl-2" data-tooltip-id="leave-comment-tooltip" onClick={() => setShowComment(!showComment)} data-testid="comment-toggle">
            <i className="bi bi-chat-left-text text-normal"></i>
          </Button>
      )
    }
    {
      showComment && <div className="default-level-comment-div position-relative">
        <EditorInput data-testid="comment-input"
          className={`mt-2 ${readOnlyMode ? 'hide-toolbar' : ''}`}
          value={comment}
          onChangeCallback={(v) => setComment(v)}
          validate={(v) => v ? setCommentError(true) : setCommentError(false)}
          readOnly={readOnlyMode} />
        {
          !readOnlyMode && <Button onClick={handleSaveComment} variant="chip-success" icon="bi-check" className="btn-save-level-comment" data-testid="confirm-button" />
        }
        <Button onClick={() => setShowComment(false)} variant="chip-accent" icon="bi-x" className="btn-cancel-level-comment" data-testid="cancel-button" />
      </div>
    }
  </>
}

export default function EvaluationMode({ settings, balancedScorecardDetails, saveAgreement, evaluationCompleted, weight, assignedTeamObjectives, individualObjectives, reviewerView = false, customConfigFetched, checkConfig, evaluationDirty, setEvaluationDirty, levels, extremeLevels, individualResultCommentMandatory, systematicResultCommentMandatory, balancedScorecardMetas, stateEvaluationFlow = {}, hideObjectives = false, previewMode = null, handleChangePreviewMode = null, handleBtnClickBlur = null, handleCompleteEvaluation = null, completeLoading = false, validateAll = null,
  weightingErrorTranslationKey = null,
  interviewEnabled = false,
  interviews = [],
  canOpenInterviewTab = false,
  fetchBalancedScorecards = null,
  fetchBalancedScorecardDetails = null,
  setInterviewDirty = null,
  interviewsData = [],
  fetchInterviews = null,
  complaints = [],
  fetchComplaints = null,
  stateCompleteEvaluationButton = <></>,
  errorField = null,
  setErrorField = null
}) {
  const { translate, editableTranslate } = useTranslation();

  const [bonus, setBonus] = useState(balancedScorecardDetails?.agreement_data?.bonus || '');

  const [showIndividualComment, setShowIndividualComment] = useState(false);
  const [showSystematicComment, setShowSystematicComment] = useState(false);

  const [individualComment, setIndividualComment] = useState(balancedScorecardDetails?.agreement_data?.comments?.individual || null);
  const [systematicComment, setSystematicComment] = useState(balancedScorecardDetails?.agreement_data?.comments?.systematic || null);

  const [individualCommentError, setIndividualCommentError] = useState(false);
  const [systematicCommentError, setSystematicCommentError] = useState(false);

  const useGeneral = useMemo(() => {
    return settings?.howToAppraisal?.includes('individual_and_systematic') && settings?.hasDifferentEvaluationLevel === false;
  }, [settings]);

  const weighted = useMemo(() => {
    return settings?.performanceResultCalculation !== 'sum_of_all_unweighted';
  }, [settings]);

  const readOnlyMode = useMemo(() => {
    return evaluationCompleted || reviewerView || weightingErrorTranslationKey;
  }, [evaluationCompleted, reviewerView, weightingErrorTranslationKey]);

  const countSystematic = useMemo(() => {
    if (balancedScorecardDetails && balancedScorecardDetails?.agreement_data?.systematicObjectives) {
      let count = 0;

      const arr = balancedScorecardDetails.agreement_data.systematicObjectives;

      if (arr?.length > 0) {
        for (const item of arr) {
          if (item.agreed) count++;
        }
      }

      return count;
    } else if (!balancedScorecardDetails) {
      return (!settings?.shouldHasSubCriteria ?
        settings?.systematicObjectiveDatagrid?.filter(o => o?.systematicObjectiveAgreeObjective).length :
        settings?.systematicObjectiveDatagrid_subCriteria?.filter(o => o?.systematicObjectiveAgreeObjective).length
      );
    }
    return 0;
  }, [settings, balancedScorecardDetails]);

  useEffect(() => {
    setIndividualCommentError(false);
  }, [showIndividualComment]);

  useEffect(() => {
    setSystematicCommentError(false);
  }, [showSystematicComment]);

  const renderEvaluationLevelSelect = (type, reference, currentVal = '', forceDisabled = false) => {
    if (currentVal === null) currentVal = '';

    let keyName = 'general';
    let arr = [];

    if (settings?.howToAppraisal.includes('individual_and_systematic') && settings.hasDifferentEvaluationLevel === false) {
      arr = settings.generalPerformanceLevelGrid;
    } else if (type === 'individual' && settings?.individualObjectivePerformanceLevelGrid && settings?.individualObjectivePerformanceLevelGrid[0]?.individualObjectiveLevel) {
      keyName = 'individualObjective';
      arr = settings.individualObjectivePerformanceLevelGrid;
    } else if (type === 'systematic' && settings?.systematicObjectivePerformanceLevelGrid && settings?.systematicObjectivePerformanceLevelGrid[0]?.systematicObjectiveLevel) {
      keyName = 'systematicObjective';
      arr = settings.systematicObjectivePerformanceLevelGrid;
    }

    return (
      <NativeSelect data-testid="level-select" className="d-inline-block" disabled={readOnlyMode || forceDisabled} onChange={(e) => handleLevelChange(e, type, reference)} value={currentVal || ''}>
        <option value=""></option>
        {
          arr?.map((item, i) => {
            return <option key={i}>{item[keyName + 'Level']}</option>
          })
        }
      </NativeSelect>
    );
  };

  const handleLevelChange = async (e, type, reference, key = 'level') => {
    if (!balancedScorecardDetails) return;

    let val = e;
    if (key === 'level') {
      val = e.target.value;

      if (e.target.type === 'checkbox' && !e.target.checked) {
        val = null;
      }
    }

    // copy, so a failed save does not leave the change in the local details
    const agreementData = structuredClone(balancedScorecardDetails.agreement_data) || {};

    if (type === 'individual') {
      if (!agreementData.individualObjectives) agreementData.individualObjectives = [];

      let found = false;
      for (let i = 0; i < agreementData.individualObjectives.length; i++) {
        if (agreementData.individualObjectives[i].type === reference.type && agreementData.individualObjectives[i].hash_id === reference.hash_id) {
          agreementData.individualObjectives[i][key] = val;
          found = true;
          break;
        }
      }
      if (!found) {
        agreementData.individualObjectives.push({ ...reference, [key]: val });
      }
    } else if (type === 'systematic') {
      const parentName = reference?.parent || reference.name;

      for (let i = 0; i < agreementData.systematicObjectives.length; i++) {
        if (agreementData.systematicObjectives[i].name === parentName) {
          if (reference?.parent) { // if is sub
            for (let j = 0; j < agreementData.systematicObjectives[i].sub.length; j++) {
              if (agreementData.systematicObjectives[i].sub[j].name === reference.name) {
                agreementData.systematicObjectives[i].sub[j][key] = val;
                break;
              }
            }
          } else {
            agreementData.systematicObjectives[i][key] = val;
          }
          break;
        }
      }
    }

    await saveAgreement(agreementData);

    if (errorField) {
      validateAll();
    }
  };

  const handleBonusChange = async (e) => {
    setBonus(e.target.value);
  };

  const handleSaveBonus = async () => {
    if (!balancedScorecardDetails) return;

    // copy, so a failed save does not leave the change in the local details
    const agreementData = structuredClone(balancedScorecardDetails.agreement_data) || {};

    const formattedBonus = formatInputNumber(bonus);
    setBonus(formattedBonus);

    agreementData.bonus = formattedBonus;

    await saveAgreement(agreementData);
  };

  const handleSaveResultComment = async (type, comment, setShow) => {
    if (!balancedScorecardDetails) return;

    // copy, so a failed save does not leave the change in the local details
    const agreementData = structuredClone(balancedScorecardDetails.agreement_data) || {};
    if (!agreementData?.comments) agreementData.comments = {};

    agreementData.comments[type] = comment;

    await saveAgreement(agreementData);

    setShow(false);
  };

  const handleSaveIndividualResultComment = () => {
    if (individualCommentError) return;

    handleSaveResultComment('individual', individualComment, setShowIndividualComment);
  };

  const handleSaveSystematicResultComment = () => {
    if (systematicCommentError) return;

    handleSaveResultComment('systematic', systematicComment, setShowSystematicComment);
  };

  const handleClickToAgreement = (e) => {
    if (['i', 'button'].includes(e?.target?.tagName?.toLowerCase()) ||
      e?.target?.getAttribute('role') === 'button') return;

    handleChangePreviewMode('agreement');
  };

  const handleManageObjectives = (e) => {
    e?.preventDefault();

    handleChangePreviewMode('agreement');
  };

  return (
    <div>
      {
        !customConfigFetched ? <div className="text-center mt-3" data-testid="loading">
          <div className="spinner-border" role="status">
            <span className="sr-only">Wird geladen...</span>
          </div>
        </div> :
          (
            checkConfig('balanced-scorecard-layout-v2') ?
              <EvaluationDUS
                settings={settings}
                balancedScorecardDetails={balancedScorecardDetails}
                handleLevelChange={handleLevelChange}
                readOnlyMode={readOnlyMode}
                levels={levels}
                countSystematic={countSystematic}
                useGeneral={useGeneral}
                extremeLevels={extremeLevels}
                weight={weight}
                weighted={weighted}
                bonus={bonus}
                handleBonusChange={handleBonusChange}
                handleSaveBonus={handleSaveBonus}
                systematicResultCommentMandatory={systematicResultCommentMandatory}
                handleSaveResultComment={handleSaveResultComment}
                systematicComment={systematicComment}
                setSystematicComment={setSystematicComment}
                showSystematicComment={showSystematicComment}
                setShowSystematicComment={setShowSystematicComment}
                errorField={errorField}
                setErrorField={setErrorField} /> :
              checkConfig('balanced-scorecard-layout-v3') ? <EvaluationStateEmployee
                settings={settings}
                balancedScorecardDetails={balancedScorecardDetails}
                handleLevelChange={handleLevelChange}
                readOnlyMode={readOnlyMode}
                levels={levels}
                countSystematic={countSystematic}
                extremeLevels={extremeLevels}
                saveAgreement={saveAgreement}
                balancedScorecardMetas={balancedScorecardMetas}
                evaluationDirty={evaluationDirty}
                setEvaluationDirty={setEvaluationDirty}
                stateEvaluationFlow={stateEvaluationFlow}
                hideObjectives={hideObjectives}
                previewMode={previewMode}
                handleChangePreviewMode={handleChangePreviewMode}
                handleBtnClickBlur={handleBtnClickBlur}
                handleCompleteEvaluation={handleCompleteEvaluation}
                completeLoading={completeLoading}
                validateAll={validateAll}
                reviewerView={reviewerView}
                interviewEnabled={interviewEnabled}
                interviews={interviews}
                canOpenInterviewTab={canOpenInterviewTab}
                fetchBalancedScorecards={fetchBalancedScorecards}
                fetchBalancedScorecardDetails={fetchBalancedScorecardDetails}
                setInterviewDirty={setInterviewDirty}
                interviewsData={interviewsData}
                fetchInterviews={fetchInterviews}
                complaints={complaints}
                fetchComplaints={fetchComplaints}
                stateCompleteEvaluationButton={stateCompleteEvaluationButton}
                errorField={errorField}
                setErrorField={setErrorField} /> :
                <div>
                  {
                    settings?.showRatingNotes && settings?.ratingNotes &&
                    <div className="feedback-div d-flex mt-4">
                      <div className="mr-2">
                        <img src={infoIcon} alt="info" />
                      </div>
                      <div className="w-100">
                        <ExpandableHtml html={settings?.ratingNotes} className="fade-blue" />
                      </div>
                    </div>
                  }

                  {
                    weightingErrorTranslationKey && <div data-testid="go-to-agreement" onClick={handleClickToAgreement} className="cursor-pointer mt-4">
                      <ErrorAlert error={{ translationKey: weightingErrorTranslationKey }} />
                    </div>
                  }

                  {
                    (settings?.howToAppraisal === 'individual_and_systematic_objective' && weighted) && <div className="text-right mt-4">
                      <div className="combination-weight-div">
                        <img src={personIcon} alt="Person icon" /> / <img src={peopleIcon} alt="People icon" />
                        <div className="d-inline-block ml-2">
                          <InputAffix suffix="%" className="peb-input-affix--sm" readOnly>
                            <Input data-testid="weight-individual-input" type="text" className="text-right" value={weight?.individual} readOnly />
                          </InputAffix>
                        </div>
                        <span className="vertical-separator mx-3">|</span>
                        <img src={toolIcon} alt="Tool icon" />
                        <div className="d-inline-block ml-2">
                          <InputAffix suffix="%" className="peb-input-affix--sm" readOnly>
                            <Input data-testid="weight-systematic-input" type="text" className="text-right" value={weight?.systematic} readOnly />
                          </InputAffix>
                        </div>
                      </div>
                    </div>
                  }

                  <div className={`mt-4 systematic-div ${settings?.shouldHasSubCriteria === true ? 'has-sub' : ''}`}>
                    <table className="table table-borderless" data-testid="assigned-team-objectives-table">
                      <tbody>
                        {
                          settings?.howToAppraisal.includes('individual') && <Fragment>
                            <tr className="thead top-row">
                              <th>{editableTranslate('balanced_scorecard.objective')}</th>
                              <th className="text-center">{editableTranslate('balanced_scorecard.target_type')}</th>
                              {
                                weighted && <th className="text-right">{editableTranslate('balance_scorecard.systematic_objective.weighted')}</th>
                              }
                              <th className="text-right">{editableTranslate('balanced_scorecard.evaluation_level')}</th>
                              <th className="text-right">{editableTranslate('balance_scorecard.value')}</th>
                              {
                                weighted && <th className="text-right">{editableTranslate('balanced_scorecard.weighted_result')}</th>
                              }
                            </tr>
                            {
                              assignedTeamObjectives && assignedTeamObjectives.map((obj, i) => {
                                let data = {};
                                if (balancedScorecardDetails?.agreement_data?.individualObjectives) {
                                  const filtered = balancedScorecardDetails?.agreement_data?.individualObjectives.filter(o => o.type === 'team' && o.hash_id === obj.hash_id);
                                  if (filtered.length > 0) data = filtered[0];
                                }

                                return <tr key={i} data-testid={`row-${obj?.hash_id}`}>
                                  <td>{obj.name}</td>
                                  <td className="text-center"><img src={peopleIcon} className="w-1rem" alt="People icon" /> <span className="v-middle">{editableTranslate('balanced_scorecard.team_objective')}</span></td>
                                  {
                                    weighted && <td className="text-right">{obj.weight}%</td>
                                  }
                                  <td className="text-right">
                                    {renderEvaluationLevelSelect('individual', { type: 'team', hash_id: obj.hash_id }, data?.level, true)}
                                    {/* <DefaultLevelComment settings={settings} data={data} extremeLevels={extremeLevels} readOnlyMode={readOnlyMode} handleSave={v => handleLevelChange(v, 'individual', data, 'comment')} /> */}
                                    <i className="bi bi-info-circle position-absolute ml-2 mt-2" data-tooltip-id="team-objective-cental-tooltip"></i>
                                  </td>
                                  <td className="text-right">{data?.value}</td>
                                  {
                                    weighted && <td className="text-right">{data?.weightedValue}</td>
                                  }
                                </tr>
                              })
                            }
                            {
                              individualObjectives && individualObjectives.map((obj, i) => {
                                let data = {};
                                if (balancedScorecardDetails?.agreement_data?.individualObjectives) {
                                  const filtered = balancedScorecardDetails?.agreement_data?.individualObjectives.filter(o => o.type === 'individual' && o.hash_id === obj.hash_id);
                                  if (filtered.length > 0) data = filtered[0];
                                }

                                return <tr key={i} className={`${errorField?.individual?.objective?.hash_id === obj.hash_id ? 'invalid-tr' : ''}`} data-testid={`row-${obj?.hash_id}`}>
                                  <td>{obj.name}</td>
                                  <td className="text-center"><img src={personIcon} className="w-1rem" alt="Person icon" /> <span className="v-middle">{editableTranslate('balanced_scorecard.individual_objective')}</span></td>
                                  {
                                    weighted && <td className="text-right">{obj.weight}%</td>
                                  }
                                  <td className="text-right">
                                    {renderEvaluationLevelSelect('individual', { type: 'individual', hash_id: obj.hash_id }, data?.level, readOnlyMode)}
                                    <DefaultLevelComment settings={settings} data={data} extremeLevels={extremeLevels} readOnlyMode={readOnlyMode} handleSave={v => handleLevelChange(v, 'individual', data, 'comment')} />
                                  </td>
                                  <td className="text-right">{data?.value}</td>
                                  {
                                    weighted && <td className="text-right">{data?.weightedValue}</td>
                                  }
                                </tr>
                              })
                            }
                            {
                              (balancedScorecardDetails && (!assignedTeamObjectives || !individualObjectives)) && <tr>
                                <td colSpan={6} className="text-center" data-testid="loading">
                                  <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="sr-only">Wird geladen...</span>
                                  </div>
                                </td>
                              </tr>
                            }
                            {
                              (!balancedScorecardDetails || (assignedTeamObjectives?.length === 0 && individualObjectives?.length === 0)) && <tr>
                                <td colSpan={6} className="text-center">
                                  {editableTranslate('evaluation.no_individual_objectives_in_lk')}
                                  <div>
                                    <a data-testid="manage-objectives-link" onClick={handleManageObjectives} href="/#" className="text-default">{editableTranslate('balanced_scorecard.manage_objectives')} <i className="bi bi-box-arrow-up-right"></i></a>
                                  </div>
                                </td>
                              </tr>
                            }
                            <tr className="last-row total-objective-tr">
                              <td colSpan={weighted ? 5 : 3} className="text-right font-weight-bold">{editableTranslate('balanced_scorecard.total_individual_objective')}:</td>
                              <td className="text-right font-weight-bold">{balancedScorecardDetails?.agreement_data?.totalValue?.individual}</td>
                            </tr>
                          </Fragment>
                        }

                        {
                          settings?.howToAppraisal === 'individual_and_systematic_objective' && <tr>
                            <td colSpan={weighted ? 6 : 4} className="px-0 no-border-bottom">
                              <hr />
                            </td>
                          </tr>
                        }

                        {
                          settings?.howToAppraisal.includes('systematic') && <DefaultSystematicObjective settings={settings} balancedScorecardDetails={balancedScorecardDetails} handleLevelChange={handleLevelChange} readOnlyMode={readOnlyMode} levels={levels?.general ?? levels?.systematic} countSystematic={countSystematic} useGeneral={useGeneral} extremeLevels={extremeLevels} weighted={weighted} errorField={errorField} />
                        }

                        <tr>
                          <td colSpan={weighted ? 6 : 4} className="mt-4 no-border-bottom"></td>
                        </tr>

                        <tr className="top-row summary-tr">
                          <th colSpan={weighted ? 3 : 2}></th>
                          <th className="text-right">{editableTranslate('balanced_scorecard.result')}</th>
                          {
                            weighted && <th colSpan={1} className="text-right">{editableTranslate('balance_scorecard.systematic_objective.weighted')}</th>
                          }
                          <th className="text-right">{editableTranslate('balanced_scorecard.total')}</th>
                        </tr>
                        {
                          settings?.howToAppraisal.includes('individual') && <tr className="summary-tr">
                            <td colSpan={weighted ? 3 : 2}>{editableTranslate('balance_scorecard.performance_level_grid.individual_objective')}
                              {
                                showIndividualComment && <div className="result-comment-div position-relative break-word">
                                  <EditorInput data-testid="comment-input-individual"
                                    className={`mt-2 ${readOnlyMode ? 'hide-toolbar' : ''}`}
                                    value={individualComment}
                                    onChangeCallback={(v) => setIndividualComment(v)}
                                    validate={(v) => v ? setIndividualCommentError(true) : setIndividualCommentError(false)}
                                    readOnly={readOnlyMode} />
                                  {
                                    !readOnlyMode && <Button onClick={handleSaveIndividualResultComment} variant="chip-success" icon="bi-check" className="btn-save-level-comment" data-testid="confirm-button" />
                                  }
                                  <Button onClick={() => setShowIndividualComment(false)} variant="chip-accent" icon="bi-x" className="btn-cancel-level-comment" data-testid="cancel-button" />
                                </div>
                              }
                            </td>
                            <td className={`text-right position-relative ${showIndividualComment ? 'align-top' : ''}`}>{balancedScorecardDetails?.agreement_data?.totalValue?.individual}
                              {
                                !showIndividualComment && (
                                  individualResultCommentMandatory ?
                                    <Button variant="ghost" className="position-absolute pl-2 top-2" data-tooltip-id="extreme-comment-tooltip" onClick={() => setShowIndividualComment(!showIndividualComment)} data-testid="comment-toggle-individual">
                                      <i className="bi bi-exclamation-circle-fill text-normal"></i>
                                    </Button> :
                                    <Button variant="ghost" className="position-absolute pl-2 top-2" data-tooltip-id="leave-comment-tooltip" onClick={() => setShowIndividualComment(!showIndividualComment)} data-testid="comment-toggle-individual">
                                      <i className="bi bi-chat-left-text text-normal"></i>
                                    </Button>
                                )
                              }
                            </td>
                            {
                              weighted && <td colSpan={1} className={`text-right ${showIndividualComment ? 'align-top' : ''}`}>{weight?.individual}%</td>
                            }
                            <td className={`text-right ${showIndividualComment ? 'align-top' : ''}`}>{balancedScorecardDetails?.agreement_data?.weightedTotalValue?.individual}</td>
                          </tr>
                        }
                        {
                          settings?.howToAppraisal.includes('systematic') && <tr className="summary-tr">
                            <td colSpan={weighted ? 3 : 2}>{editableTranslate('balanced_scorecard.systematic_objective')}
                              {
                                showSystematicComment && <div className="result-comment-div position-relative break-word">
                                  <EditorInput data-testid="comment-input-systematic"
                                    className={`mt-2 ${readOnlyMode ? 'hide-toolbar' : ''}`}
                                    value={systematicComment}
                                    onChangeCallback={(v) => setSystematicComment(v)}
                                    validate={(v) => v ? setSystematicCommentError(true) : setSystematicCommentError(false)}
                                    readOnly={readOnlyMode} />
                                  {
                                    !readOnlyMode && <Button onClick={handleSaveSystematicResultComment} variant="chip-success" icon="bi-check" className="btn-save-level-comment" data-testid="confirm-button" />
                                  }
                                  <Button onClick={() => setShowSystematicComment(false)} variant="chip-accent" icon="bi-x" className="btn-cancel-level-comment" data-testid="cancel-button" />
                                </div>
                              }
                            </td>
                            <td className={`text-right position-relative ${showSystematicComment ? 'align-top' : ''}`}>{balancedScorecardDetails?.agreement_data?.totalValue?.systematic}
                              {
                                !showSystematicComment && (
                                  systematicResultCommentMandatory ?
                                    <Button variant="ghost" className="position-absolute pl-2 top-2" data-tooltip-id="extreme-comment-tooltip" onClick={() => setShowSystematicComment(!showSystematicComment)} data-testid="comment-toggle-systematic">
                                      <i className="bi bi-exclamation-circle-fill text-normal"></i>
                                    </Button> :
                                    <Button variant="ghost" className="position-absolute pl-2 top-2" data-tooltip-id="leave-comment-tooltip" onClick={() => setShowSystematicComment(!showSystematicComment)} data-testid="comment-toggle-systematic">
                                      <i className="bi bi-chat-left-text text-normal"></i>
                                    </Button>
                                )
                              }
                            </td>
                            {
                              weighted && <td colSpan={1} className={`text-right ${showSystematicComment ? 'align-top' : ''}`}>{weight?.systematic}%</td>
                            }
                            <td className={`text-right ${showSystematicComment ? 'align-top' : ''}`}>{balancedScorecardDetails?.agreement_data?.weightedTotalValue?.systematic}</td>
                          </tr>
                        }
                        {
                          settings?.allowChangesOfResult && <tr className="summary-tr">
                            <td colSpan={weighted ? 3 : 2}>{editableTranslate('balanced_scorecard.bonus_penalty')}</td>
                            <td></td>
                            {
                              weighted && <td colSpan={1}></td>
                            }
                            <td className="pt-0"><Input data-testid="bonus-input" type="text" size="sm" className="ml-auto text-right" value={bonus} onChange={handleBonusChange} onBlur={readOnlyMode ? undefined : handleSaveBonus} readOnly={readOnlyMode} maxLength={24} /></td>
                          </tr>
                        }
                        <tr className={`${settings?.shouldConvertResultToPayoutPoints ? '' : 'last-row'} overall-row summary-tr`}>
                          <td colSpan={weighted ? 6 : 4}>
                            <div className="d-flex justify-content-between">
                              <strong>{editableTranslate('balanced_scorecard.overall_result')}:</strong>
                              <strong>{balancedScorecardDetails?.agreement_data?.result}</strong>
                            </div>
                          </td>
                        </tr>
                        {
                          settings?.shouldConvertResultToPayoutPoints && <tr className="last-row summary-tr">
                            <td colSpan={weighted ? 6 : 4}>
                              <div className="d-flex justify-content-between">
                                <strong>{editableTranslate('balanced_scorecard.payout_points')}</strong>
                                <strong>{balancedScorecardDetails?.agreement_data?.payout_points}</strong>
                              </div>
                              <PayoutPointsMapping settings={settings} result={balancedScorecardDetails?.agreement_data?.result} />
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
          )
      }
      <ReactTooltip id="leave-comment-tooltip" place="bottom" content={translate('tooltips.balanced_scorecard.leave_comment_tooltip')} />
      <ReactTooltip id="extreme-comment-tooltip" place="bottom" content={translate('tooltips.balanced_scorecard.extreme_comment_tooltip')} />
      <ReactTooltip id="team-objective-cental-tooltip" place="bottom" content={translate('tooltips.balanced_scorecard.team_objective_central_tooltip')} />
    </div>
  );
}
